<!-- Expandable Row Template -->
<ng-template #customRow let-row>
	<div class="expanded-row-container layout-auto-1-auto">
		<div>
			<exg-select [ngModel]="editor.oeGetIndexOf(row.tb_oeIDClone)"
			            (ngModelChange)="editor.oeSelectionChange($event, row)"
			            [caption]="'oe'"
			            [list]="editor.oeList"
			            listdisplay="oeName" name="oeName">
			</exg-select>
			<exg-select [(ngModel)]="row.tb_enmIdent_TypClone"
			            [caption]="enumSvc.getFieldCaption(editor.enmTable, editor.enmName)"
			            [list]="editor.enmList"
			            listdisplay="enmText" name="type" >
			</exg-select>
			<exg-input [(ngModel)]="row.tbNameClone"
	               [caption]="enumSvc.getFieldCaption('Textbaustein','tbName')"
	               name="tbName"
	               type="text">
			</exg-input>
			<exg-input [(ngModel)]="row.tbTextShortClone"
	               [caption]="enumSvc.getFieldCaption('Textbaustein','tbTextShort')"
	               name="tbTextShort"
	               type="text">
			</exg-input>
		</div>
		<div style="min-height: 500px">
			<editor *ngIf="MCEinit" class="content app-border-none-tiny"
			        [(ngModel)]="row.tbTextClone"
			        [init]="MCEinit">
			</editor>
		</div>
		<div class="spawn-reverse">
			<button (click)="editor.delete(row)"
			        class="md-btn">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="editor.save(row)"
			        class="md-btn">
				{{getGlobal('Save')}}
			</button>
		</div>
	</div>
</ng-template>

<div class="content md3-surface">
	<div class="content md3-card-on-surface layout-auto-1-auto">
		<!-- Search Header -->
		<exg-search-bar (Search)="TBList.search($event)"
		                [placeholder]="getRessource('SearchHeaderPlaceholder')"
		                class="span-layout">
			<ng-template #rightTemplate>
				<i (click)="loadTBData()" class="search-action fal fa-sync"></i>
				<i (click)="openCreateModal()" class="search-action fal fa-plus"></i>
				<i class="search-action fal fa-gears"
				   (click)="openTableSettings($event)">
				</i>
				<exg-table-settings [tableDef]="TBList.tableDefinition"
				                    [metaInfo]="TBList.MetaInfo"
				                    localStorageID="Textbaustein">
				</exg-table-settings>
			</ng-template>
		</exg-search-bar>
		<div class="content">
			<exg-table #VCTBList
	               selectKey="tbID"
	               [metaInfo]="TBList.MetaInfo"
	               [displayState]="TBList.state"
	               [rowSource]="TBList.data"
			           [tableDef]="TBList.tableDefinition"
			           [distinctTableName]="'Textbaustein'"
			           [allowSingleSelection]="true"
			           [allowMultiSelection]="false"
			           [selectSource]="TBList.selectedRow"
			           [distinctData]="TBList.distinctData"
			           [allowRowExpansion]="true"
			           [expandedArray]="[]"
			           [expandedTemplate]="customRow"

			           (FilterActivation)="loadTBData()"
			           (loadDistinct)="TBList.getDistinctData($event)"
	               (RowChange)="TBList.selectionChanged($event)"
			>
			</exg-table>
		</div>
		<!-- Pager -->
		<exg-pager (PageChange)="TBList.pageChanged($event)"
		           [pagingSource]="TBList.paging"
		           class="span-layout">
		</exg-pager>
	</div>
</div>
